"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import { CompactJobsFeedItemFragmentDoc } from "@/gql/graphql"
import { RedactedCompactJobsFeedItem } from "./components/RedactedCompactJobsFeedItem"
import { UnredactedCompactJobsFeedItem } from "./components/UnredactedCompactJobsFeedItem"

graphql(`
  fragment CompactJobsFeedItem on JobPosting {
    id

    owner {
      id
      __typename
    }

    ...RedactedCompactJobsFeedItem
    ...UnredactedCompactJobsFeedItem
  }
`)

interface Props {
  jobPost: FragmentType<typeof CompactJobsFeedItemFragmentDoc> | null | undefined
}

export const CompactJobsFeedItem: React.FC<Props> = props => {
  const jobPost = useFragment(CompactJobsFeedItemFragmentDoc, props.jobPost)

  const ownerTypename = jobPost?.owner?.__typename
  const owner =
    ownerTypename &&
    ["IndividualClient", "IndividualCreative", "RedactedIndividualClient", "RedactedIndividualCreative"].includes(
      ownerTypename
    )
      ? jobPost?.owner
      : null
  const ownerIsClient = owner?.__typename === "IndividualClient"
  const ownerIsCreative = owner?.__typename === "IndividualCreative"
  const ownerIsRedactedClient = owner?.__typename === "RedactedIndividualClient"
  const ownerIsRedactedCreative = owner?.__typename === "RedactedIndividualCreative"

  const isRedacted = ownerIsRedactedClient || ownerIsRedactedCreative
  const isUnredacted = ownerIsClient || ownerIsCreative

  return (
    <>
      {isRedacted ? <RedactedCompactJobsFeedItem jobPost={jobPost} /> : null}
      {isUnredacted ? <UnredactedCompactJobsFeedItem jobPost={jobPost} /> : null}
    </>
  )
}
